module.exports = __webpack_public_path__ + "img/atl.0171c775.png";